import React, {Component} from 'react'
import SEO from '../components/SEO'
import Layout from '../components/Layout'
import Signupnow2 from '../components/CTAsections/Signupnow2'
import Hlmpricing from '../components/PricingComps/Hlmpricing'

const DEFAULT_USERSNUM = 5
// const MIN_USERSNUM = 1
// const MAX_USERSNUM = 10

// const USERS_TO_PRICE = {
//   1: 39,
//   2: 38,
//   3: 37,
//   4: 36,
//   5: 35,
//   6: 34,
//   7: 33,
//   8: 32,
//   9: 31,
//   10: 30,
// }

export default class Plans extends Component {
  constructor(props) {
    super(props)

    this.state = {
      number_users: DEFAULT_USERSNUM,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      error: '',
    }
  }

  onChange = e => {
    let key = e.target.dataset.key
    let update = {[key]: e.currentTarget.value}
    if (key === this.state.error) {
      update.error = ''
    }
    this.setState(update)
  }

  submitRequest = () => {
    // Sanitize input
    let {firstName, lastName, email, phone} = this.state

    let error = ''

    if (!firstName) {
      error = 'firstName'
    } else if (!lastName) {
      error = 'lastName'
    } else if (!email) {
      error = 'email'
    } else if (!phone) {
      error = 'phone'
    }

    if (error) {
      return this.setState({error})
    }

    // submit information here
  }

  toggleModal = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  state = {
    open: false,
  }

  toggleModalvid = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    return (
      <>
        <Layout>
          <SEO
            title="Pricing (HLM) HomeLight Listing Management | For Real Estate teams agent's, assistant's, transaction coordinators and broker managers. Advanced branding, sharing, analytics, and collaboration tools."
            meta={[
              {
                name: `title`,
                content:
                  "Pricing (HLM) HomeLight Listing Management | For Real Estate teams agent's, assistant's, transaction coordinators and broker managers. Advanced branding, sharing, analytics, and collaboration tools.",
              },
              {
                name: `description`,
                content: 'Trusted by cooperating agents and their clients. Pro Membership offers advanced features for teams, brokerages, and active agents.',
              },
              {
                property: `og:image`,
                content: 'https://disclosures-cdn.s3-us-west-2.amazonaws.com/assets/Marketing/hlm-mktg-site/HLM+Social+Final+1.png',
              },
              {property: 'og:image:width', content: '600'},
              {property: 'og:image:height', content: '315'},
              {property: `og:title`, content: '(HLM) HomeLight Listing Management '},
              {property: 'og:url', content: 'https://disclosures.io'},
              {
                property: `og:description`,
                content: 'Trusted by cooperating agents and their clients. Pro Membership offers advanced features for teams, brokerages, and active agents.',
              },
              {property: 'og:site_name', content: '(HLM) HomeLight Listing Management '},
              {property: `og:type`, content: `website`},
              {name: `twitter:card`, content: `summary_large_image`},
              {name: `twitter:site`, content: `@Disclosuresio`},
              {name: `twitter:creator`, content: '@Disclosuresio'},
              {name: `twitter:title`, content: "(HLM) HomeLight Listing Management | On-market to offer accepted, faster! - Sign Up Now! (It's free!)"},
              {
                name: `twitter:description`,
                content: 'Trusted by cooperating agents and their clients. Pro Membership offers advanced features for teams, brokerages, and active agents.',
              },
              {
                name: 'keywords',
                content:
                  '(HLM) HomeLight Listing Management , Disclosures.io, Disclosures.io pricing, Disclosures.io Features, Disclosures.io BBB, real estate broker tools, real estate listing management, disclosure package, property package, real estate disclosure, realtor crm, nhd report, property disclosure, real estate transaction management, realtor tools, tc tools, real estate crm, real estate software, buyers agent, home disclosure, listing agent,',
              },
            ]}
          />

          {/* BODY */}

          <div className="container grid-xl">
            <a
              href="https://w.disclosures.io/lunch-and-learn"
              target="_blank"
              className="p th-home--padmob th-home--mobilefonth4 text-primary-3 "
              rel="noopener noreferrer"
              style={{color: '', fontSize: '.6rem', textDecoration: 'none', padding: '0 .5rem 0 .5rem'}}>
              {' '}
              <div
                className="th-home--padmob th-home--mobhid btn btn-md text-left btn-primary box-shadow zvideobottom"
                style={{position: 'fixed', bottom: '3%', left: '1.5%'}}>
                &nbsp;Join the next lunch-and-learn &nbsp;
                <i className="fas fa-laptop" />
              </div>
            </a>

            <div className=" text-dark text-center bg-white th-home--mobilefonth3 th-home--mobiletop-demo pt-16" style={{}}>
              <div className="h2   th-home--mobilefonth2 th-home--padmob text-dark pt-4" style={{}}>
                Simple, straightforward pricing
              </div>
            </div>

            <div className="">
              <Hlmpricing />
            </div>
          </div>

          <div className="container grid-xl  th-home--deskhid" style={{}}>
            {/* Individual */}
            <div className="columns mt-0 ">
              <div className="column mt-16 col-4 col-sm-12 col-md-12 col-xl-4 col-lg-12 ">
                <div className="th-home--plan  text-center box-shadow">
                  <div className="panel-header  th-plans-card-header">
                    <div className="panel-title  h2 th-plans-headerTitle  ">Basic Membership</div>
                    <p className="th-plans-headerSubTitle" style={{minHeight: '2rem', lineHeight: '1.6rem'}}>
                      <b> Best for: part-time, once-in-a-while, helping out.</b>
                      <br />
                      Create and share Property Info Packets.
                    </p>

                    <div className="columns   px-12 py-8 text-white">
                      <div className="column ">
                        <a className="btn btn-block btn-primary" style={{border: '0px #cdcdcd solid'}} onClick={this.toggleModalvid}>
                          Free - Sign Up Now
                        </a>
                        {this.state.open && (
                          <div className="modal active" id="share-mod">
                            <a className="modal-overlay" aria-label="Close" onClick={this.toggleModalvid} />
                            <div className="modal-container " role="document">
                              <div className="modal-header text-dark" style={{borderBottom: '2px #ffffff solid'}}>
                                <a className="btn btn-clear float-right " aria-label="Close" onClick={this.toggleModalvid} />
                              </div>
                              <div className="modal-body  text-center modal-body-uni text-dark">
                                <h3 class="pb-2 text-center">Getting started is easy, and free!</h3>
                                <p class="pb-6 ">Enter the email that you would like as your main account login. </p>
                                <div className="">
                                  <SignupForm size="md" />
                                </div>
                                <img
                                  className=" img-responsive pt-16 container "
                                  src="https://cdn.disclosures.io/assets/logos-2020/logotype-hl-palette-light-bg-open-3x.png"
                                  alt="Disclosures.io"
                                  width="300"
                                  height="auto"
                                  style={{maxWidth: '250px'}}
                                />
                                <p class="pt-12 text-small">
                                  Already have an account?{' '}
                                  <a href="https://app.disclosures.io/auth/login" target="_blank">
                                    Log In Here
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div style={{display: 'flex', flexDirection: 'column', height: 'inherit'}}>
                    <ul
                      className="  th-home--planul"
                      style={{
                        listStyleType: 'none',
                        flex: 1,
                        lineHeight: '.9rem',
                        textAlign: 'left',
                        padding: '1rem',
                        color: '#00414b',
                      }}>
                      <li class="ul-price-head ">Pre-Market</li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Easy TC/Assistant access</li>
                        <li>Seller Signature Import</li>
                        <li>Create comprehensive Property Info Packets</li>
                        <li style={{color: '#e2e2e2'}}>Scan documents</li>
                        <li style={{color: '#e2e2e2'}}>Save custom document templates </li>
                      </ul>

                      <li class="ul-price-head " style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        On-Market
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Share Unlimited Property Info Packets</li>
                        <li>Sharable link for marketing materials</li>
                        <li style={{color: '#e2e2e2'}}>Buyer Interest Reports (activity tracking)</li>
                        <li style={{color: '#e2e2e2'}}>Broadcast updates to viewers </li>
                        <li style={{color: '#e2e2e2'}}>Blind copy mass messaging to clients </li>
                      </ul>

                      <li class="ul-price-head " style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Offers
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Receive offers</li>
                        <li>Submit offers</li>
                        <li>Accept offers</li>
                        <li>Automatic offers terms comparison sheet</li>
                        <li style={{color: '#e2e2e2'}}>Custom offers dashboard for sellers&nbsp;</li>
                      </ul>

                      <li class="ul-price-head " style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Administrative
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Unlimited space (no fee for storage)</li>
                        <li>Easy TC/Assistant access</li>
                        <li>DocuSign integration</li>
                        <li>Easy export of all data & contacts</li>
                        <li style={{color: '#e2e2e2'}}>iOS App</li>
                        <li style={{color: '#e2e2e2'}}>Additional iOS app functionality</li>
                        <li style={{color: '#e2e2e2'}}>Custom branding</li>
                      </ul>
                      <li class="ul-price-head " style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Support
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Weekly live webinar training</li>
                        <li>Help center guides and training</li>
                        <li style={{color: '#e2e2e2'}}>1-on-1 customer support</li>
                        <li style={{color: '#e2e2e2'}}>Team training </li>
                      </ul>

                      <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                        Agent & Client Services
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Trade In™</li>
                        <li>Cash Offer™</li>
                        <li>Closing Services</li>
                        <li>
                          *Agent approval required,&nbsp;
                          <a href="/agents" style={{textDecoration: 'underlin', color: '#465aff'}}>
                            learn more here
                          </a>
                          .
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
              {/* PRO MEMBERSHIP */}
              <div className="column mt-2 col-4 col-sm-12 col-md-12 col-xl-4 col-lg-12 th-home--mobiletop-price-pro">
                <div className="th-home--plan  text-center " style={{boxShadow: '1px 6px 10px 0px rgba(70, 182, 255,0.92)'}}>
                  <div className="bg-primary text-white p py-2">BEST FOR ACTIVE AGENTS</div>

                  <div className="panel-header  th-plans-card-header">
                    <div className="panel-title  h2 th-plans-headerTitle ">Pro Membership</div>
                    <p className="th-plans-headerSubTitle" style={{minHeight: '2rem', lineHeight: '1.6rem'}}>
                      <b>For full-time agents putting up numbers.</b>
                      <br />
                      Manage listings + track activity + group messaging.
                    </p>
                    <div className="columns  grid-sm px-10 py-10 text-white">
                      <div className="column container hide-lg">
                        <a className="btn btn-block  btn-lg btn-success" style={{border: '0px #cdcdcd solid', fontSize: '.9em'}} onClick={this.toggleModalvid}>
                          $39 MONTHLY - SIGN UP NOW
                        </a>
                      </div>

                      <div className="column container show-xs show-sm show-md show-lg hide-xl">
                        <a className="btn btn-block btn-success " style={{border: '0px #cdcdcd solid'}} onClick={this.toggleModalvid}>
                          $39 MONTHLY - SIGN UP NOW
                        </a>
                      </div>
                    </div>
                  </div>

                  <div style={{display: 'flex', flexDirection: 'column', height: 'inherit', paddingTop: '1.1em'}}>
                    <ul
                      className="  th-home--planul"
                      style={{
                        listStyleType: 'none',
                        flex: 1,
                        lineHeight: '.9rem',
                        textAlign: 'left',
                        padding: '1rem',
                        color: '#00414b',
                        fontSize: '.77rem',
                      }}>
                      <li class="ul-price-head" style={{fontWeight: 'bolder'}}>
                        Pre-Market
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Easy TC/Assistant access</li>
                        <li>Seller Signature Import</li>
                        <li>Create comprehensive Property Info Packets</li>
                        <li>Scan documents</li>
                        <li>Save custom document templates </li>
                      </ul>

                      <li class="ul-price-head" style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        On-Market
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Share Unlimited Property Info Packets</li>
                        <li>Sharable link for marketing materials</li>

                        <li>Buyer Interest Reports (activity tracking)</li>

                        <li>Broadcast updates to viewers </li>
                        <li>Blind copy mass messaging to clients </li>
                      </ul>

                      <li class="ul-price-head" style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Offers
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Receive offers</li>
                        <li>Submit offers</li>
                        <li>Accept offers</li>
                        <li>Automatic offers terms comparison sheet</li>
                        <li>Custom offers dashboard for sellers&nbsp;</li>
                      </ul>

                      <li class="ul-price-head" style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Administrative
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Unlimited space (no fee for storage)</li>
                        <li>Easy TC/Assistant access</li>
                        <li>DocuSign integration</li>
                        <li>Easy export of all data & contacts</li>
                        <li>iOS App</li>
                        <li>Additional iOS app functionality</li>
                        <li>Custom branding</li>
                      </ul>
                      <li class="ul-price-head" style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Support
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Weekly live webinar training</li>
                        <li>Help center guides and training</li>
                        <li>1-on-1 customer support</li>
                        <li style={{color: '#e2e2e2'}}>Team training </li>
                      </ul>

                      <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                        Agent & Client Services
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Trade In™</li>
                        <li>Cash Offer™</li>
                        <li>Closing Services</li>
                        <li>
                          *Agent approval required,&nbsp;
                          <a href="/agents" style={{textDecoration: 'underlin', color: '#465aff'}}>
                            learn more here
                          </a>
                          .
                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="column mt-16 col-4 col-sm-12 col-md-12 col-lg-12 col-xl-4 " id="anchor-dteams">
                <div className="th-home--plan  text-center box-shadow">
                  <div className="panel-header  th-plans-card-header">
                    <div className="panel-title  h2 th-plans-headerTitle ">Teams & Brokerages</div>
                    <p className="th-plans-headerSubTitle" style={{minHeight: '2rem', lineHeight: '1.6rem'}}>
                      <b>From two-person teams to large brokerages.</b>
                      <br />
                      Advanced branding, analytics, and collaboration.
                    </p>

                    <div className=" container grid-xl px-12 py-8 text-white h4 align-center">
                      <div className="columns">
                        <div className="column container grid-xl">
                          <a
                            href="https://meetings.disclosures.io/meetings/bryansteel/team-demo"
                            className="btn btn-block btn-primary "
                            target="_blank"
                            style={{border: '0px #cdcdcd solid'}}>
                            <i className="fas fa-calendar-alt" />
                            &nbsp; Schedule a Team Demo
                          </a>
                          <div className="modal modal-sm text-primary text-left" id="teams-mod" style={{height: '100%'}}>
                            <a href="/pricing" className=" modal-overlay" aria-label="Close" />
                            <div className="modal-container " role="document" style={{position: 'fixed', right: '0%', height: '100%'}}>
                              <div className="modal-header">
                                <div className="modal-title text-dark text-center  ">Schedule a team demo.</div>
                              </div>
                              <div className="modal-body " style={{minHeight: '90%'}}>
                                <form
                                  data-netlify="true"
                                  method="POST"
                                  netlify-honeypot="bot-field"
                                  hidden
                                  className="form-group columns px-4"
                                  name="demoRequestForm"
                                  action="/thanks">
                                  <div className="column col-12">
                                    <input type="hidden" name="form-name" value="demoRequestForm" />
                                    <label className="form-label text-small text-dark">
                                      First Name
                                      <input name="firstName" className="form-input input-sm" type="text" placeholder="First Name" />
                                    </label>
                                  </div>
                                  <div className="column col-12 " style={{marginTop: '.1rem'}}>
                                    <label className="form-label text-small text-dark" type="text">
                                      Last Name
                                    </label>
                                    <input name="lastName" className="form-input input-sm" type="text" placeholder="Last Name" />
                                  </div>
                                  <div className="column col-12" style={{marginTop: '.1rem'}}>
                                    <label className="form-label text-small text-dark">Email</label>
                                    <input
                                      name="email"
                                      className="form-input input-sm"
                                      placeholder="Email"
                                      type="email"
                                      pattern="[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$"
                                    />
                                  </div>
                                  <div className="column col-12 " style={{marginTop: '.1rem'}}>
                                    <label className="form-label text-small text-dark">Company</label>
                                    <input name="brokerageName" className="form-input input-sm" type="text" placeholder="Company or Brokerage" />
                                  </div>

                                  <div className="column col-12 " style={{marginTop: '.1rem'}}>
                                    <label className="form-label text-small text-dark">State</label>
                                    <input name="state" className="form-input input-sm" type="text" placeholder="Which state do you live in?" />
                                  </div>

                                  <div className="form-group column col-12 " style={{marginTop: '.1rem'}}>
                                    <label className="form-label text-small text-dark">Your Title</label>
                                    <select name="userType" className="form-select text-dark text-small" style={{width: '100%', height: '1.8rem'}}>
                                      <option>Agent</option>
                                      <option>Manager / Team Lead</option>
                                      <option>Transaction Coordinator</option>
                                      <option>Assistant</option>
                                      <option>Other</option>
                                    </select>
                                  </div>
                                  <div className="column col-12 " style={{marginTop: '.1rem'}}>
                                    <label className="form-label text-small text-dark">How many people will join the demo?</label>
                                    <input name="numberOfAgentsJoining" className="form-input input-sm" type="number" placeholder="1-100" />
                                  </div>

                                  <div className="column col-12 " style={{marginTop: '.1rem'}}>
                                    <label className="form-label text-small text-dark">Please recommend a demo date.</label>
                                    <input name="demoDateSuggest" className="col-8 form-input input-sm" type="date" placeholder="Suggest a date for the demo" />
                                  </div>

                                  <div className="column col-12 " style={{marginTop: '.1rem'}}>
                                    <label className="form-label text-small text-dark">Please recommend a demo time.</label>
                                    <input name="demoTimeSuggest" className="col-8 form-input input-sm" type="time" placeholder="Suggest a time for the demo" />
                                  </div>

                                  <div className="column col-7 py-6">
                                    <button type="submit" className="btn btn-sm btn-block bg-primary-3" style={{}}>
                                      Submit
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{display: 'flex', flexDirection: 'column', height: 'inherit'}}>
                    <ul
                      className="  th-home--planul"
                      style={{
                        listStyleType: 'none',
                        flex: 1,
                        lineHeight: '.9rem',
                        textAlign: 'left',
                        padding: '1rem',
                        color: '#00414b',
                        fontSize: '.77rem',
                      }}>
                      <li class="ul-price-head" style={{fontWeight: 'bolder'}}>
                        Pre-Market
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Easy TC/Assistant access</li>
                        <li>Seller Signature Import</li>
                        <li>Create comprehensive Property Info Packets</li>
                        <li>Scan documents</li>
                        <li>Save custom document templates </li>
                      </ul>

                      <li class="ul-price-head" style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        On-Market
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Share Unlimited Property Info Packets</li>
                        <li>Sharable link for marketing materials</li>

                        <li>Buyer Interest Reports (activity tracking)</li>

                        <li>Broadcast updates to viewers </li>
                        <li>Blind copy mass messaging to clients </li>
                      </ul>

                      <li class="ul-price-head" style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Offers
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Receive offers</li>
                        <li>Submit offers</li>
                        <li>Accept offers</li>
                        <li>Automatic offers terms comparison sheet</li>
                        <li>Custom offers dashboard for sellers&nbsp;</li>
                      </ul>

                      <li class="ul-price-head" style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Administrative
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Unlimited space (no fee for storage)</li>
                        <li>Easy TC/Assistant access</li>
                        <li>DocuSign integration</li>
                        <li>Easy export of all data & contacts</li>
                        <li>iOS App</li>
                        <li>Additional iOS app functionality</li>
                        <li>Custom branding</li>
                      </ul>

                      <li class="ul-price-head" style={{fontWeight: 'bolder', paddingTop: '1em'}}>
                        Team Control
                      </li>
                      <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                        <li>Team training </li>
                        <li>Advanced Top Down Branding</li>
                        <li>Multiple user privileges (for assistants and TC’s)</li>
                        <li>Team collaboration on listings</li>
                        <li>Custom user and performance reports</li>
                        <li>Single-Sign-On available (SSO)</li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Individual Pro */}
            </div>

            {/* FAQ */}

            <div className="container mb-8 grid-xl  th-home--mobiletop">
              <div className="text-center">
                <div className="h2 th-home--mobilefonth2" style={{marginTop: '6rem', color: '#000000', padding: '2rem 2rem 1rem 2rem'}}>
                  Membership Quick FAQ
                </div>
                <div className="h4 th-home--mobilefonth4" style={{marginTop: '0em', color: '#00414b', marginBottom: '2em', padding: '0rem 1rem 0rem 1rem'}}>
                  Answers to a few questions that most agents have about a Disclosures.io Membership
                </div>
                <p className=" container grid-lg text-left" style={{color: '#00414b', marginBottom: '4em'}}>
                  <span style={{fontWeight: 'bolder'}}>Do you have a free trial?</span>
                  <br />
                  There is no free trial for Pro features but you can sign up for a Basic membership for Free. If you are interested in a Pro Membership, we'd
                  suggest signing up for the monthly subscription; that way you can turn it on and off as needed.
                  <br />
                  <br />
                  <span style={{fontWeight: 'bolder'}}>Is this service for TCs or Agents?</span>
                  <br />
                  Agents and TCs use Disclosures.io to better manage listings. TCs love the organization and easy PDF tools. Agents love tracking interest in
                  their listing and the professional presentation for their clients.
                  <br />
                  <br />
                  <span style={{fontWeight: 'bolder'}}>Can I pay per transaction?</span> <br />
                  A Pro membership for Disclosures.io is available for purchase as either a monthly or annual subscription. Subscriptions can be canceled at any
                  time.
                  <br />
                  <br />
                  <span style={{fontWeight: 'bolder'}}>Can I link my Property Package to the MLS?</span> <br />
                  Yes. Every property package that you create comes with a unique Share Link, which can be copy+pasted into the confidential remarks section of
                  your listing in the MLS.
                </p>
              </div>
            </div>

            <a
              href="https://w.disclosures.io/lunch-and-learn"
              target="_blank"
              className="p th-home--padmob th-home--mobilefonth4 text-primary-3 "
              rel="noopener noreferrer"
              style={{color: '', fontSize: '.6rem', textDecoration: 'none', padding: '0 .5rem 0 .5rem'}}>
              {' '}
              <div
                className="th-home--padmob th-home--mobhid btn btn-md text-left btn-primary box-shadow"
                style={{position: 'fixed', bottom: '3%', left: '1.5%'}}>
                &nbsp;Join the next lunch-and-learn &nbsp;
                <i className="fas fa-laptop" />
              </div>
            </a>
          </div>
          <Signupnow2 />
        </Layout>
      </>
    )
  }
}
